// extracted by mini-css-extract-plugin
module.exports = {"elSection":"Section_elSection__2o5DQ","cardSection":"Section_cardSection__1Vs3W","loading":"Section_loading__1FexC"};